const PATHS = {};

PATHS.LOGIN = "/login";
PATHS.HOME = "/user/home";
PATHS.EXTERNAL_CONFIRM_LOGIN = "/authConfirm/:token";

PATHS.CHNAGE_PASSWORD = "/user/changePassword";
PATHS.FIRST_CHANGE_PASSWORD = "/user/firstChangePassword";

PATHS.GO_TO_FORM = "/user/complete/form/:code/:uuid";

PATHS.LIST_PROVIDER = "/adm/provider/list";
PATHS.NEW_PROVIDER = "/adm/provider/new";
PATHS.UPDATE_PROVIDER = "/adm/provider/update/:uuid";

PATHS.LIST_REQUEST_PROVIDER = "/adm/requestProvider/list";
PATHS.NEW_REQUEST_PROVIDER = "/adm/requestProvider/new";
PATHS.UPDATE_REQUEST_PROVIDER = "/adm/requestProvider/update/:uuid";
PATHS.ALL_DATA_REQUEST_PROVIDER = "/adm/requestProvider/view/:uuid";

PATHS.FORM = "/adm/form";
PATHS.FORM_LIST = "/adm/form/list";
PATHS.CREATE_FORM = "/adm/form/form/new";
PATHS.UPDATE_FORM = "/adm/form/form/update/:uuid";

PATHS.COURSE = "/adm/course";
PATHS.LIST_COURSE = "/adm/course/list";
PATHS.CREATE_COURSE = "/adm/course/form/new";
PATHS.UPDATE_COURSE = "/adm/course/form/update/:uuid";

PATHS.MEETING = "/adm/meeting";
PATHS.LIST_MEETING = "/adm/meeting/list";
PATHS.CREATE_MEETING = "/adm/meeting/form/new";
PATHS.UPDATE_MEETING = "/adm/meeting/form/update/:uuid";

PATHS.SESSION = "/adm/session";
PATHS.LIST_SESSION = "/adm/session/list";
PATHS.CREATE_SESSION = "/adm/session/form/new";
PATHS.CREATE_SESSION_FROM_MEETING = "/adm/session/form/new/:meetingUuid";
PATHS.UPDATE_SESSION = "/adm/session/form/update/:uuid";
PATHS.LIST_ATTENDANCE_FROM_SESSION = "/adm/session/attendance/:uuid";

PATHS.ATTENDANCE = "/adm/attendance";
PATHS.LIST_ATTENDANCE = "/adm/attendance/list";
PATHS.CREATE_ATTENDANCE = "/adm/attendance/form/new";
PATHS.UPDATE_ATTENDANCE = "/adm/attendance/form/update/:uuid";

PATHS.EXT_LOGIN = "/ext/login";
PATHS.FORGOTTEN_PASSWORD = "/forgottenPassword";

PATHS.NEW_USER = "/adm/user/new";

PATHS.SETTINGS = "/adm/settings";

PATHS.LIST_CENTERS = "/adm/centers/list";

export default PATHS;
